<mat-form-field
  class="lib-input coin-form-field-outline coin-form-field-outline--{{ matFormFieldClass() }} no-margin"
  matTooltipClass="error-tooltip"
  appearance="outline"
  floatLabel="always"
  [matTooltip]="errorMessage() ?? errorTooltip()"
  [matTooltipDisabled]="!touched() || !showErrorTooltip()"
  [class.rtl]="direction() === 'rtl'">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  }
  @if (prefix()) {
    <ng-container matPrefix>
      @if (typeof prefix() === 'string') {
        <p>{{ prefix() }}</p>
      } @else {
        <ng-container *ngTemplateOutlet="prefixAsTemplate()"></ng-container>
      }
    </ng-container>
  }
  <input
    #textInput
    type="text"
    matInput
    autocomplete="off"
    [placeholder]="placeholder()"
    [matAutocompleteDisabled]="!autoCompleteOptions()?.length"
    [matAutocomplete]="autoComplete"
    [ngModel]="value"
    [disabled]="disabled()"
    [dir]="direction()"
    (blur)="onTouch()"
    (ngModelChange)="setValueDebounced$.next($event)" />
  @if (clearable() && !loading()) {
    <button
      class="no-style"
      (click)="onClear()">
      <mat-icon>close</mat-icon>
    </button>
  } @else {
    @if (icon() || loading() || suffix()) {
      @if (loading()) {
        <div class="loading">
          <v2-turbine
            [withPole]="false"
            [shadow]="false"></v2-turbine>
        </div>
      } @else if (icon()) {
        <mat-icon>{{ icon() }}</mat-icon>
      } @else {
        <ng-container matSuffix>
          @let suf = suffix();
          @if (typeof suf === 'string') {
            <p>{{ suf }}</p>
          } @else {
            <ng-container *ngTemplateOutlet="suf"></ng-container>
          }
        </ng-container>
      }
    }
  }

  <mat-autocomplete #autoComplete="matAutocomplete">
    @for (option of autoCompleteOptions(); track option) {
      <mat-option [value]="option">{{ option }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
